import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Modal, Alert } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import { baseUrl } from "../../../../services/config";
import { Link, useHistory } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Input } from "../../../../_metronic/_partials/controls";

import Select from "react-select";
import jwt_token from "../../../../services/authToken";
import { useAlert } from "react-alert";
import { PremissionChecker } from "../../../../services/PremissionChecker";
import { Checkbox, Divider } from "antd";
import { useSelector } from "react-redux";

const EditUser = ({ show, onHide, reload, headofficeDetail }) => {
  const user = useSelector((state) => state.user.user);
  const alert = useAlert();
  const history = useHistory();
  const authToken = jwt_token();
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorsLis, setErrorsLis] = useState("");
  let [errorcreate, seterrorcreate] = useState("Please fill all fields");
  let [isallfields, setisallfields] = useState(false);
  let [previousdata, setpreviousdata] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [singleRoleList, setSingleRoleList] = useState([]);
  const [campuses, setCampuses] = useState();
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedCampuses, setSelectedCampuses] = useState([]);

  const [addloading, setaddloading] = useState(false);
  const initialValues = {
    first_name: headofficeDetail.first_name,
    last_name: headofficeDetail.last_name || "",
    title: headofficeDetail.office_title || "",
    email: headofficeDetail.email || "",
    password: "",
  };

  const [duplicateModal, setDuplicateModal] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [roleId, setRoleId] = useState("");
  const [addLoading, setAddLoading] = useState(false);

  const [attachModal, setattachModal] = useState(false);
  const [list, setList] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [searchTermRole, setSearchTermRole] = useState("");
  const [myRoleIndexArray, setMyRoleIndexArray] = useState([]);
  const [SelectedId, setSelectedId] = useState("");

  useEffect(() => {
    if (headofficeDetail) {
      const defaultRoles = headofficeDetail?.roles?.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      const defaultCampuses = headofficeDetail?.campuses?.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setSelectedRoles(defaultRoles);
      setSelectedCampuses(defaultCampuses);
    }
  }, [headofficeDetail]);

  useEffect(() => {
    getRoles();
    getAllCampus();
    getPermissions();
  }, []);

  const getAllCampus = async () => {
    await fetch(`${baseUrl}/campus`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        let arr = [{ label: "Select All", value: "select_all" }];

        data.payload.forEach((element) => {
          arr.push({
            label: element.name,
            value: element.id,
          });
        });
        setCampuses(arr);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const getRoles = () => {
    fetch(`${baseUrl}/roles`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSingleRoleList(data.payload);

        let arr = [{ label: "Select All", value: "select_all" }];
        data.payload.forEach((element) => {
          arr.push({
            label: element.name,
            value: element.id,
          });
        });
        setRoleList(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getPermissions = () => {
    fetch(`${baseUrl}/asset/permissions`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())

      .then((data) => {
        data.payload.sort((a, b) => a.name.localeCompare(b.name));
        convertToIndexArray(data.payload);
        setList(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const AddHeadOfficeHandle = async (data) => {
    console.log("this is data", data);

    const fd = new FormData();

    fd.append("first_name", data.first_name);
    fd.append("last_name", data.last_name);
    fd.append("email", data.email);
    fd.append("office_title", data.title);
    if (data.password != "") {
      fd.append("password", data.password);
    }
    selectedRoles.map((role, i) => {
      fd.append(`role_ids[${i}]`, role.value);
    });
    selectedCampuses.map((role, i) => {
      fd.append(`campus_ids[${i}]`, role.value);
    });

    setaddloading(true);
    fetch(`${baseUrl}/users/${headofficeDetail.id}?_method=PUT`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      body: fd,
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            disableLoading();
            setisallfields(false);
            seterrorcreate("");
            setaddloading(false);
            alert.show("Successfully Updated");
            reload();
            onHide(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.show(msg, {
                type: "error",
                transition: "fade",
              });
            });
            disableLoading();
            setisallfields(false);
            setaddloading(false);
            seterrorcreate("");
            onHide(false);
          }
        })
      )
      .catch((err) => {
        console.log(err);
        disableLoading();
        setisallfields(false);
        setaddloading(false);
        seterrorcreate("");
        alert.show("Failed");
        onHide(false);
      });
  };

  const createEroors = (errors, touched) => {
    if (Object.keys(errors).length === 0) {
      seterrorcreate("");
      setisallfields(false);
      return;
    }

    if (errors.first_name && touched.first_name) {
      seterrorcreate(errors.first_name);
      setisallfields(true);
      return;
    }

    if (errors.last_name && touched.last_name) {
      seterrorcreate(errors.last_name);
      setisallfields(true);
      return;
    }

    if (errors.email && touched.email) {
      seterrorcreate(errors.email);
      setisallfields(true);
      return;
    }

    if (errors.title && touched.title) {
      seterrorcreate(errors.title);
      setisallfields(true);
      return;
    }
  };

  const HeadValidationSchema = Yup.object().shape({
    first_name: Yup.string()
      .min(3, "Name is atleast of 3 characters")
      .max(50, "Name is mximum of 50 characters")
      .required("Name Is Required"),

    email: Yup.string()
      .email("Wrong email format")
      .required("Email Is Required"),

    last_name: Yup.string()
      .min(3, "Last Name is atleast of 3 characters")
      .max(50, "Last Name is mximum of 50 characters")
      .required("Last  Name is Required"),
    title: Yup.string()
      .min(3, "Title is atleast of 3 characters")
      .max(50, "Title is mximum of 50 characters")
      .required("Title Required "),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const handleRolesChange = (selectedOptions) => {
    if (selectedOptions == null) {
      setSelectedRoles([]);
      return;
    }
    if (selectedOptions.some((option) => option.value === "select_all")) {
      setSelectedRoles(
        roleList.filter((option) => option.value !== "select_all")
      );
    } else {
      setSelectedRoles(selectedOptions);
    }
  };

  const handleCampusChange = (selectedOptions) => {
    if (selectedOptions == null) {
      setSelectedCampuses([]);
      return;
    }
    if (selectedOptions.some((option) => option.value === "select_all")) {
      setSelectedCampuses(
        campuses.filter((option) => option.value !== "select_all")
      );
    } else {
      setSelectedCampuses(selectedOptions);
    }
  };

  const addDuplicateRoleHandler = async () => {
    if (roleName == "" || roleId == "") {
      setisallfields(true);
      setDuplicateModal(false);
      onHide(false);
      return alert.error("All Fields Are Required");
    }
    setisallfields(false);
    setAddLoading(true);
    const data = {
      name: roleName,
      role_id: roleId,
      user_id: headofficeDetail.id,
    };

    await fetch(`${baseUrl}/duplicate-role`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success(data.metadata.message);
            setRoleName("");
            setRoleId("");
            setAddLoading(false);
            setDuplicateModal(false);
            onHide(false);
            reload();
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddLoading(false);
            setDuplicateModal(false);
          } else {
            alert.show("Something Went Wrong");
            setAddLoading(false);
            setDuplicateModal(false);
          }
        })
      )
      .catch((err) => {
        setAddLoading(false);
        setDuplicateModal(false);
        console.log(err);
      });
  };

  const openAttachModal = (item) => {
    getPermissionsbyRole(item?.roles[0]?.id);
    // setSelectedId(item.id)
    // setattachModal(true)
  };

  useEffect(() => {
    if (!list.length) return;

    const isAllChecked = list.every((item) => item.checked);
    setCheckAll(isAllChecked);
  }, [list]);

  const getPermissionsbyRole = (id) => {
    console.log("running");

    fetch(`${baseUrl}/roles/${id}/permissions`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const permissionIds = data.payload.map((p) => p.id);

        const updatedList = list.map((item) => ({
          ...item,
          checked: permissionIds.includes(item.id),
          selected: permissionIds.includes(item.id),
        }));

        setList(updatedList);
        setSelectedId(id);
        setattachModal(true);
      });
  };

  const attachSubmit = () => {
    const permissionsList = list
      .filter((item) => item.checked)
      .map((item) => item.id);
    const formData = new FormData();

    for (let i = 0; i < permissionsList.length; i++) {
      formData.append(`permissions[${i}]`, permissionsList[i]);
    }

    fetch(`${baseUrl}/roles/${SelectedId}/attach-permissions`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          setattachModal(false);
          alert.success(data.metadata.message);
        } else if (!data.metadata.success) {
          Object.values(data.metadata.message).map((msg) => {
            alert.error(msg);
            setattachModal(false);
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const convertToIndexArray = (array) => {
    const dummy = array.map((item, i) => {
      const newObj = new Object();
      newObj.index = i;
      newObj.name = item.name.split(".")[0];
      return newObj;
    });

    const uniqueArr = dummy.reduce((result, current) => {
      const existingObject = result.find((item) => item.name === current.name);
      if (!existingObject) {
        result.push(current);
      }
      return result;
    }, []);
    let finnal = [];
    uniqueArr.map((ss) => {
      finnal.push(ss.index);
    });

    console.log(finnal);
    setMyRoleIndexArray(finnal);
  };

  const handleCheckboxChange = (itemId) => {
    setList((prev) =>
      prev.map((item) =>
        item.id === itemId ? { ...item, checked: !item.checked } : item
      )
    );
  };

  const handleCheckAllChange = (e) => {
    const checked = e.target.checked;

    setList((prev) =>
      prev.map((item) => ({
        ...item,
        checked,
      }))
    );
  };

  const filtered = list.filter((role) => {
    const term = searchTermRole.toLowerCase();
    return role?.description
      ? role?.description.toLowerCase().includes(term)
      : true;
  });

  const textChanger = (text) => {
    const spacedStr = text.replace(/_/g, " ");

    const words = spacedStr.split(" ");
    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );
    const convertedStr = capitalizedWords.join(" ");
    return convertedStr;
  };
  return (
    <>
      <Modal
        size="lg"
        show={show}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            Add New User
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {addloading ? (
            <b style={{ color: "green" }}>
              User Updating Please Wait {` `}{" "}
              <span className="spinner-border"></span>
            </b>
          ) : (
            <Formik
              initialValues={initialValues}
              validationSchema={HeadValidationSchema}
              enableReinitialize={true}
              onSubmit={(data, { validateForm }) => {
                enableLoading();
                AddHeadOfficeHandle(data);
              }}
            >
              {(props) => {
                const {
                  handleSubmit,
                  errors,
                  touched,
                  values,
                  isSubmitting,
                  isValid,
                } = props;
                setErrorsLis(errors);
                createEroors(errors, touched);

                return (
                  <Form
                    onSubmit={handleSubmit}
                    className="form form-label-right"
                  >
                    <div className="card-body">
                      <div className="container">
                        <div>
                          <div className="form-group row">
                            <div className="col-lg-6">
                              <label for="first_name">
                                First Name{" "}
                                <span style={{ color: "red" }}> *</span>
                              </label>
                              <Field
                                component={Input}
                                name="first_name"
                                control="input"
                                type="input"
                                colCount="col-6"
                                value={values.first_name}
                                placeholder="Enter First Name"
                              />
                            </div>

                            <div className="col-lg-6">
                              <label for="last_name">
                                Last Name{" "}
                                <span style={{ color: "red" }}> *</span>
                              </label>
                              <Field
                                component={Input}
                                name="last_name"
                                control="input"
                                type="text"
                                colCount="col-6"
                                placeholder="Enter Last Name"
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <div className="col-lg-6">
                              <label>
                                Email <span style={{ color: "red" }}> *</span>
                              </label>
                              <Field
                                component={Input}
                                name="email"
                                control="input"
                                type="email"
                                colCount="col-6"
                                placeholder="Enter Your Email"
                              />
                            </div>
                            <div className="col-lg-6">
                              <label>
                                Password{" "}
                                <span style={{ color: "red" }}> *</span>
                              </label>
                              <Field
                                component={Input}
                                name="password"
                                control="input"
                                type="password"
                                colCount="col-6"
                                placeholder="Enter Your Password"
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <div className="col-lg-12">
                              <label>
                                Office Title{" "}
                                <span style={{ color: "red" }}> *</span>
                              </label>
                              <Field
                                component={Input}
                                name="title"
                                control="input"
                                type="input"
                                colCount="col-12"
                                placeholder="Enter Office Title"
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            {selectedRoles && (
                              <div className="col-lg-6 mt-4">
                                <label>
                                  Select Roles{" "}
                                  <span style={{ color: "red" }}> *</span>
                                </label>
                                <Select
                                  isMulti
                                  value={selectedRoles}
                                  onChange={(newVal) =>
                                    handleRolesChange(newVal)
                                  }
                                  options={roleList}
                                />
                              </div>
                            )}
                            {selectedRoles && (
                              <div className="col-lg-6 mt-4">
                                <label>
                                  Select Campuses{" "}
                                  <span style={{ color: "red" }}> *</span>
                                </label>
                                <Select
                                  isMulti
                                  value={selectedCampuses}
                                  onChange={(newVal) =>
                                    handleCampusChange(newVal)
                                  }
                                  options={campuses}
                                />
                              </div>
                            )}
                          </div>

                          <div className="form-group row">
                            <div className="col-lg-12">
                              <button
                                type="button"
                                className="btn btn-primary mx-2"
                                onClick={() => setDuplicateModal(true)}
                              >
                                Duplicate Role
                              </button>
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() =>
                                  openAttachModal(headofficeDetail)
                                }
                              >
                                Attach Permissions
                              </button>
                            </div>
                          </div>

                          {isallfields ? (
                            <>
                              <Alert
                                variant="danger"
                                onClose={() => setisallfields(false)}
                                dismissible
                              >
                                <Alert.Heading>
                                  Oh snap! You got an error!
                                </Alert.Heading>
                                <p>{errorcreate}</p>
                              </Alert>
                            </>
                          ) : null}

                          <div className="d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-primary font-weight-bold btn_width px-9 py-4 my-3 mx-4"
                            >
                              <span>Submit</span>
                              {loading && (
                                <span className="ml-3 spinner spinner-white"></span>
                              )}
                            </button>
                            <ToastContainer
                              position="top-right"
                              autoClose={5000}
                              hideProgressBar={false}
                              newestOnTop={false}
                              closeOnClick
                              rtl={false}
                              pauseOnFocusLoss
                              draggable
                              pauseOnHover
                            />
                            <Link to="/users">
                              <button
                                onClick={() => {
                                  setisallfields(false);
                                  onHide(false);
                                }}
                                type="button"
                                className="btn btn-danger btn_width font-weight-bold px-9 py-4 my-3"
                              >
                                Cancel
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          )}
        </Modal.Body>
      </Modal>

      {/* Add Duplicate Role */}
      <Modal show={duplicateModal} size="lg">
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            Add Duplicate Role
          </Modal.Title>
        </Modal.Header>

        {addLoading ? (
          <b style={{ color: "green", padding: "10px" }}>
            Duplicate Role Adding Please Wait {` `}{" "}
            <span className="spinner-border"></span>
          </b>
        ) : (
          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <label htmlFor="role_id">
                  Select Role To Copy
                  <span style={{ color: "red" }}>*</span>
                </label>

                <select
                  className="form-select form-control"
                  name="role_id"
                  value={roleId}
                  onChange={(e) => {
                    if (e.target.value == "") {
                      setisallfields(true);
                    } else {
                      setisallfields(false);
                    }
                    let roleId = e.target.value;
                    if (roleId == "") {
                      setRoleName("");
                      setRoleId("");
                    } else {
                      setRoleId(roleId);
                      let searchRole = singleRoleList.find(
                        (item) => item.id == roleId
                      );
                      setRoleName(searchRole?.name);
                    }
                  }}
                  style={{ backgroundColor: "white" }}
                  aria-label="Default select example"
                >
                  <option value="">Select Role To Copy</option>
                  {singleRoleList.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label htmlFor="role_name">
                  Role Name<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="role_name"
                  value={roleName}
                  className="form-control"
                  placeholder="Enter Role Name"
                  onChange={(e) => {
                    if (e.target.value == "") {
                      setisallfields(true);
                    } else {
                      setisallfields(false);
                    }
                    setRoleName(e.target.value);
                  }}
                />
              </div>
            </div>

            <br />
            <br />
            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please fill or select all fields</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>
        )}

        <Modal.Footer>
          <button
            className="btn btn-primary w-200px mx-2"
            onClick={addDuplicateRoleHandler}
            disabled={addLoading}
          >
            Add Duplicate Role
            {addLoading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
          <button
            className="btn btn-danger btn_width"
            onClick={() => {
              setDuplicateModal(false);
              setisallfields(false);
              setRoleName("");
              setRoleId("");
            }}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>

      {/* Attach Permissions */}
      <Modal centered size="xl" show={attachModal}>
        <Modal.Header>{"Attach Permission"}</Modal.Header>
        <Modal.Body>
          <div
            style={{ height: "500px", overflowY: "scroll" }}
            className="permsonScoller"
          >
            <div
              style={{
                position: "sticky",
                top: 2,
                backgroundColor: "white",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                }}
              >
                <div className="container-fluid">
                  <Checkbox checked={checkAll} onChange={handleCheckAllChange}>
                    Check All
                  </Checkbox>
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by permissions name"
                    onChange={(e) => setSearchTermRole(e.target.value)}
                    value={searchTermRole}
                  />
                </div>
              </div>

              <Divider style={{ marginBottom: "0px" }} />
            </div>
            <div
            //   style={{
            //       display: 'flex',
            //       flexWrap: 'wrap',

            //   }}
            >
              <div className="row container-fluid">
                {filtered.map((user, i) => (
                  <>
                    {myRoleIndexArray.includes(i) ? (
                      <>
                        <h4 className={"mt-5"}>
                          {textChanger(user.name.split(".")[0])}
                        </h4>
                      </>
                    ) : null}
                    <div className="col-md-4">
                      <span
                      //   style={{ width: "25%"}}
                      >
                        <Checkbox
                          style={{ paddingRight: "30px", paddingTop: "5px" }}
                          className="givingspace"
                          checked={user.checked}
                          onChange={(event) => handleCheckboxChange(user.id)}
                        >
                          {/* <Tooltip placement="top" title={user.description}> */}
                          {user.description}
                          {/* </Tooltip> */}
                        </Checkbox>
                      </span>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            onClick={() => setattachModal(false)}
            className="btn btn-danger"
          >
            Cancel
          </button>
          {PremissionChecker(user, "role.permissions_attach") ? (
            <button onClick={() => attachSubmit()} className="btn btn-primary">
              Attach
            </button>
          ) : null}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditUser;
